import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "solutions-main"
  }, [_c("h3", {
    staticClass: "module-title"
  }, [_vm._v("解决方案")]), _c("ul", {
    staticClass: "list"
  }, _vm._l(_vm.solutionList, function (item, index) {
    return _c("li", {
      key: index,
      on: {
        click: function ($event) {
          return _vm.$router.push(item.path);
        }
      }
    }, [_c("div", {
      staticClass: "li-left"
    }, [_c("h4", [_vm._v(_vm._s(item.title))]), _c("p", {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.desc))])]), _c("div", {
      staticClass: "li-right"
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: "Text-to-Speech"
      }
    })])]);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };